import type { RouteRecordRaw } from 'vue-router';

import adminRoutes from '@/router/modules/adminRoutes';
import authRoutes from '@/router/modules/authRoutes';
import dataModelRoutes from '@/router/modules/dataModelRoutes';
import deviceRoutes from '@/router/modules/deviceRoutes';
import errorRoutes from '@/router/modules/errorRoutes';
import fleetRoutes from '@/router/modules/fleetRoutes';
import machineRoutes from '@/router/modules/machineRoutes';
import miscRoutes from '@/router/modules/miscRoutes';
import namespaceRoutes from '@/router/modules/namespaceRoutes';
import templateRoutes from '@/router/modules/templateRoutes';

const routes: RouteRecordRaw[] = [
  ...miscRoutes,
  ...machineRoutes,
  ...deviceRoutes,
  ...templateRoutes,
  ...namespaceRoutes,
  ...dataModelRoutes,
  ...fleetRoutes,
  ...adminRoutes,
  ...authRoutes,
  ...errorRoutes,
];

export default routes;
